export default "__VITE_ASSET__3f669b45__"